import styled from 'styled-components';
import {
    spaceMixin,
    token,
} from '@zillow/constellation';

import { Col } from '@zillow/zrs-comet';

export const StyledCol = styled(Col)`
    padding-bottom: ${spaceMixin('md')};

    /* 768 */
    @media (min-width: ${token('breakpoints.lg') - 1}px) {
        padding-bottom: ${spaceMixin('sm')};
    }
    /* 1440 */
    @media (min-width: 1440px) {
        padding-bottom: ${spaceMixin('md')};
    }
`;
